import MasterDetailModal from '@/modules/base/components/modal/master-detail-modal/master-detail-modal'
import React from 'react'
import MissingStaffDataLeft from './missing-staffData-left'
import MissingStaffDataRight from './missing-staffData-right'

interface MissingStaffDataModalProps {
  open: boolean;
  onClose: () => void;
}

const MissingStaffDataModal: React.FC<MissingStaffDataModalProps> = (props) => {
  const { open, onClose } = props

  return (
    <MasterDetailModal
      showCloseIcon
      open={open}
      onClose={onClose}
      width="1150px"
      height="800px"
      leftPanelContent={<MissingStaffDataLeft onSave={onClose} onClose={onClose} />}
      rightPanelContent={<MissingStaffDataRight />}
    >
    </MasterDetailModal>
  )
}

export default MissingStaffDataModal
